import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsService } from 'src/app/core/utils.service';
import { ListVopRequestParams, VopRequestStatus } from 'src/app/core/vop-request.service';
import {
  VOP_REQUEST_ID_LABEL,
  VOP_REQUEST_STATUS_LABEL,
  VOP_REQUEST_RESULT_LABEL,
  VOP_REQUEST_BENEFICIARY_FIRSTNAME_LABEL_LABEL,
  VOP_REQUEST_BENEFICIARY_LASTNAME_LABEL,
  VOP_REQUEST_BENEFICIARY_TAX_CODE_LABEL,
  VOP_REQUEST_BENEFICIARY_IBAN_LABEL,
  VOP_REQUEST_ORDER_ID_LABEL,
  VOP_REQUEST_BUYER_ID_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-vop-request-filters',
  templateUrl: './vop-request-filters.component.html',
  styleUrls: ['./vop-request-filters.component.scss'],
})
export class VopRequestFiltersComponent {
  @Input() filters?: ListVopRequestParams;
  @Output() filter_clear: EventEmitter<ListVopRequestParams> = new EventEmitter<ListVopRequestParams>();

  constructor(private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        if (!this.filters) return false;
        return this.filters[k as keyof typeof this.filters] != null;
      });
    }
    return [];
  }

  getLabelByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    console.log(key);
    console.log(available_keys);
    switch (key) {
      case available_keys[0]:
        return VOP_REQUEST_ID_LABEL;
      case available_keys[1]:
        return VOP_REQUEST_STATUS_LABEL;
      case available_keys[2]:
        return VOP_REQUEST_RESULT_LABEL;
      case available_keys[3]:
        return VOP_REQUEST_BENEFICIARY_FIRSTNAME_LABEL_LABEL;
      case available_keys[4]:
        return VOP_REQUEST_BENEFICIARY_LASTNAME_LABEL;
      case available_keys[5]:
        return VOP_REQUEST_BENEFICIARY_TAX_CODE_LABEL;
      case available_keys[6]:
        return VOP_REQUEST_BENEFICIARY_IBAN_LABEL;
      case available_keys[7]:
        return VOP_REQUEST_ORDER_ID_LABEL;
      case available_keys[8]:
        return VOP_REQUEST_BUYER_ID_LABEL;
      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    switch (key) {
      case available_keys[0]:
        return this.filters?.vop_request_id || '-';
      case available_keys[1]:
        return this.getVopRequestStatusLabel(this.filters?.status);
      case available_keys[2]:
        return this.filters?.result || '-';
      case available_keys[3]:
        return this.filters?.beneficiary_firstname || '-';
      case available_keys[4]:
        return this.filters?.beneficiary_lastname || '-';
      case available_keys[5]:
        return this.filters?.beneficiary_tax_code || '-';
      case available_keys[6]:
        return this.filters?.beneficiary_iban || '-';
      case available_keys[7]:
        return this.filters?.order_id || '-';
      case available_keys[8]:
        return this.filters?.buyer_id || '-';
      default:
        return '';
    }
  }

  getVopRequestStatusLabel(status?: VopRequestStatus): string {
    if (!status) return '';
    return this.utils_service.getVopRequestStatusLabel(status);
  }
}
